import { ConditionRegistryItem } from '../../../registry/condition/ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
export class ConditionsChoiceOption extends ConditionRegistryCategory {
    label = 'Antwortoption';
    constructor(parent) {
        super(parent);
        super.init();
    }
    option_selected = () => new ConditionRegistryItem({
        /* label: 'Antwortoption ausgewählt', */
        eval: ({ option }) => !!option && option.isSelected,
    });
    option_soc = () => new ConditionRegistryItem({
        /* label: 'Antwortoption ausgewählt oder Frage fertig', */
        eval: ({ option }) => (!!option && option.isSelected) || option.question.answeringInfo.isQuestionCompleted,
    });
    option_notselected = () => new ConditionRegistryItem({
        /*  label: 'Antwortoption nicht ausgewählt', */
        eval: ({ option }) => !!option && option.isNotSelected,
    });
    option_tobeselected = () => new ConditionRegistryItem({
        /*  label: 'Antwortoption soll noch ausgewählt werden', */
        eval: ({ option }) => !!option && option.isOpenToBeSelected,
    });
    option_correct = () => new ConditionRegistryItem({
        /*  label: 'Antwortoption soll ausgewählt werden (richtige Option)', */
        eval: ({ option }) => !!option && option.shouldBeSelected,
    });
    option_wrong = () => new ConditionRegistryItem({
        /* label: 'Antwortoption soll NICHT ausgewählt werden', */
        eval: ({ option }) => !!option && !option.shouldBeSelected,
    });
    option_selectedcorrect = () => new ConditionRegistryItem({
        /* label: 'Antwortoption wurde korrekterweise ausgewählt', */
        eval: ({ option }) => !!option && option.isCorrectlySelected,
    });
    option_selectedwrong = () => new ConditionRegistryItem({
        /* label: 'Antwortoption wurde fälschlicherweise ausgewählt', */
        eval: ({ option }) => !!option && option.isWronglySelected,
    });
}
